module.exports = __webpack_public_path__ + "media/images/icons/twotone/file-image-480778359676ee6a42dac586021bc3b4.svg";